/* ==================================================================
   GB — Collection grid "Product loading" enhancement (CMS select on
   main-collection-product-grid: Load more button / Infinite scroll;
   loaded only in those modes).

   How it works, and why it's safe with custom cards:
   · The next page is fetched through Shopify's Section Rendering API
     (next-page URL straight from liquid on the sentinel — filters and
     sort params ride along) and its #product-grid items are appended.
     Cards are server-rendered by the SAME liquid as page 1, so custom
     card markup is identical by construction; gb-card-swatches are
     custom elements and auto-upgrade on append with no rebinding.
   · Sold-out consolidation (only when the grid's "Out of stock
     products" is At the end — the sentinel says so): after each
     append, every li[data-gb-available="false"] moves to the end of
     the grid in stable order. Per-page server ordering thus becomes
     GLOBAL ordering across everything loaded — the thing classic
     pagination cannot do.
   · Dawn's reveal animations: appended items are handed to the global
     initializeScrollAnimationTrigger so they animate in normally.
   · Filters/sort: facets.js replaces #ProductGridContainer wholesale;
     a MutationObserver re-inits against the fresh DOM (per-element
     bound flags, so nothing double-binds).
   · Classic pagination stays in the DOM underneath; CSS hides it only
     when JS runs (fallback for crawlers / no-JS / JS failure).
   ================================================================== */
(function () {
  var OBSERVER_MARGIN = '600px';

  function consolidateSoldOut(grid) {
    var soldOut = grid.querySelectorAll(':scope > li[data-gb-available="false"]');
    soldOut.forEach(function (item) {
      grid.appendChild(item); // stable: keeps sold-out relative order
    });
  }

  function bindLoader(sentinel) {
    if (sentinel.dataset.gbBound === 'true') return;
    sentinel.dataset.gbBound = 'true';

    var mode = sentinel.getAttribute('data-gb-mode');
    var sectionId = sentinel.getAttribute('data-gb-section-id');
    var consolidate = sentinel.getAttribute('data-gb-consolidate') === 'true';
    var nextUrl = sentinel.getAttribute('data-gb-next-url');
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    // Even with nothing left to load, a directly-opened page 2 in
    // at_the_end mode benefits from one pass (no-op on page 1).
    if (consolidate) consolidateSoldOut(grid);
    if (!nextUrl) {
      // Nothing to enhance (single page, or a direct last-page landing
      // where pagination must stay usable) — never activate.
      sentinel.remove();
      return;
    }

    // Activation flag: pagination hides and the loader UI shows ONLY
    // from here on — the CSS is inert without this class, so broken
    // or blocked JS leaves stock pagination fully working.
    var collectionWrap = sentinel.closest('.collection--gb-enhanced-loading');
    if (collectionWrap) collectionWrap.classList.add('gb-loader-active');

    var button = sentinel.querySelector('[data-gb-load-more]');
    var spinner = sentinel.querySelector('.gb-grid-loader__spinner');
    var loading = false;
    var observer = null;

    function retire() {
      if (observer) observer.disconnect();
      sentinel.remove();
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      if (button) button.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');

      var joiner = nextUrl.indexOf('?') === -1 ? '?' : '&';
      fetch(nextUrl + joiner + 'section_id=' + encodeURIComponent(sectionId))
        .then(function (response) {
          if (!response.ok) throw new Error('GB grid loader: HTTP ' + response.status);
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var newSentinel = doc.querySelector('[data-gb-grid-loader]');
          if (!newGrid) throw new Error('GB grid loader: no grid in response');

          var items = Array.prototype.slice.call(newGrid.children);
          items.forEach(function (item) {
            grid.appendChild(item);
          });

          if (consolidate) consolidateSoldOut(grid);

          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(grid);
          }

          nextUrl = newSentinel ? newSentinel.getAttribute('data-gb-next-url') : null;
          loading = false;

          if (!nextUrl) {
            retire();
          } else {
            if (button) button.classList.remove('hidden');
            if (spinner) spinner.classList.add('hidden');
          }
        })
        .catch(function () {
          // Fail safe: deactivate — classic pagination reappears,
          // loader UI hides, and we step aside.
          loading = false;
          if (collectionWrap) collectionWrap.classList.remove('gb-loader-active');
          retire();
        });
    }

    if (mode === 'infinite') {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext();
          });
        },
        { rootMargin: OBSERVER_MARGIN }
      );
      observer.observe(sentinel);
    } else if (button) {
      button.addEventListener('click', loadNext);
    }
  }

  function init() {
    document.querySelectorAll('[data-gb-grid-loader]').forEach(bindLoader);
  }

  function watchFacetRerenders() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    new MutationObserver(function () {
      init(); // fresh DOM after filter/sort — new sentinel, unbound
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      watchFacetRerenders();
    });
  } else {
    init();
    watchFacetRerenders();
  }

  // Theme editor: re-init after the section re-renders.
  document.addEventListener('shopify:section:load', init);
})();
